(function() {
    'use strict';

    angular
        .module('jotApp')
        .directive('columnToHide', columnToHide);

    function columnToHide($compile) {
        var directive = {
            restrict: 'A',
            scope: false,
            compile : compileFunc
        };

        return directive;

        function compileFunc(scope, element, attrs, parentCtrl) {
            $('tr[column-to-hide]').each(function (index, vaue) {
                $(this).removeAttr('column-to-hide');
                $(this).attr('ng-show',true);
            });
            $('th[column-to-hide]').each(function (index, vaue) {
                var name = $(this).attr('column-to-hide');
                var storageName = $('ul[hide-column-menu]').attr('hide-column-menu');
                var visibilityCondition = $(this).attr('ng-if') == null ? true : $(this).attr('ng-if');
                $('ul[hide-column-menu]').append('<li ng-if="' + visibilityCondition + '" hide-column-by="' + storageName + '.' + name + '"><input type="checkbox" id="' + name + '"><span class="fake-checkbox"><span class="glyphicon glyphicon-ok"></span></span><span>' + name + '</span></input></li>');
                $(this).removeAttr('column-to-hide');
                $(this).attr('ng-show', '!vm.hide.' + name);
            });
            $('td[column-to-hide]').each(function (index, vaue) {
                var name = $(this).attr('column-to-hide');
                $(this).removeAttr('column-to-hide');
                $(this).attr('ng-show', '!vm.hide.' + name);
            });
        }
    }
})();
